const PROJECTS = {
  get: function() {
    var projects = [];
    projects.push({
      id: 'd17e',
      title: 'd17e.com',
      titleImg: '../images/d17e.jpg',
      shortDescription:
        "Taking my React and JavaScript skills beyond following along with tutorials and books, while at the same time building a place online that's all me. Yay, me! I apologize ahead for any gratuitous self-promotion."
    });
    projects.push({
      id: 'pinwall',
      title: 'Thelooca - Pinwall',
      titleImg: 'images/pinwall.jpg',
      shortDescription:
        'In collaboration with Thomas Delbeke a.k.a Thelooca we built a pinball machine in Unity that was video mapped onto a lifesize building for people to play on through some custom built hardware.'
    });
    projects.push({
      id: 'toomanydjs',
      title: '2ManyDjs - Video to DMX',
      titleImg: 'images/toomanydjs.jpg',
      shortDescription:
        "Coming up with a solution to translate part of a video feed into DMX signals that controlled the lighting in real-time for 2ManyDj's DJ booth. This was done using mainly Processing and Max/MSP."
    });
    projects.push({
      id: 'motek-dyut',
      title: 'Motek - Do You Us Too?',
      titleImg: 'images/motek-dyut.jpg',
      shortDescription:
        "Creating a real-time app that projects pre-edited footage in sync with live music onto 3 gauze screens and mixing this with two live feeds for the 'Do You Us Too' tour by Motek. Built with Max/Msp and a bunch of hardware."
    });
    // projects.push({
    //   id: "vjing",
    //   title: "New Media & VJ Work",
    //   titleImg: "images/vjing.jpg",
    //   shortDescription:
    //     "Being intrigued by the intersection between art and technology forced me to explore some of that realm and lead me to creating (what was then called) 'new-media' workshops and doing VJ work as a side-hustle."
    // });
    return projects;
  }
};

export default PROJECTS.get();
